import { PaymentItem } from "../types/payment";
import { Filters } from "../components/HistoryFilter";
// import API from "../lib/axios";
import API_BACK from "../lib/axiosBack";

interface PaymentResponse {
  content: PaymentItem[];
  page: {
    size: number;
    number: number;
    totalElements: number;
    totalPages: number;
  };
}

function calculatePageSize(): number {
  const rowHeight = 48;
  const offset = 300;
  const availableHeight = window.innerHeight - offset;
  return Math.max(5, Math.floor(availableHeight / rowHeight));
}

let currentSize = calculatePageSize();
const listeners = new Set<() => void>();

window.addEventListener("resize", () => {
  currentSize = calculatePageSize();
  listeners.forEach((fn) => fn());
});

export const subscribeToResize = (fn: () => void) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

export const getPaymentHistory = async (
  page = 0,
  size = currentSize,
  filters?: Filters
): Promise<PaymentResponse> => {
  const token = localStorage.getItem("accessToken");

  const params: any = {
    page,
    size,
    sort: "creationTime,DESC",
  };

  if (filters) {
    if (filters.creationTimeFrom && !filters.creationTimeTo) {
      params.creationTimeFrom = new Date(
        `${filters.creationTimeFrom}T00:00:00`
      ).toISOString();
      params.creationTimeTo = new Date(
        `${filters.creationTimeFrom}T23:59:59`
      ).toISOString();
    }

    if (filters.creationTimeTo && !filters.creationTimeFrom) {
      params.creationTimeFrom = new Date(
        `${filters.creationTimeTo}T00:00:00`
      ).toISOString();
      params.creationTimeTo = new Date(
        `${filters.creationTimeTo}T23:59:59`
      ).toISOString();
    }

    if (filters.creationTimeFrom && filters.creationTimeTo) {
      params.creationTimeFrom = new Date(
        `${filters.creationTimeFrom}T00:00:00`
      ).toISOString();
      params.creationTimeTo = new Date(
        `${filters.creationTimeTo}T23:59:59`
      ).toISOString();
    }
    if (filters) {
      if (filters.amountFrom !== undefined && filters.amountFrom < 0) {
        throw new Error("Amount from cannot be negative");
      }
      if (filters.amountTo !== undefined && filters.amountTo < 0) {
        throw new Error("Amount to cannot be negative");
      }
    }

    if (filters.statuses?.length) params.statuses = filters.statuses;
    if (filters.paymentId) params.paymentId = filters.paymentId;
    if (filters.merchantId) params.merchantId = filters.merchantId;
    if (filters.amountFrom !== undefined)
      params.amountFrom = filters.amountFrom;
    if (filters.amountTo !== undefined) params.amountTo = filters.amountTo;
  }

  try {
    const response = await API_BACK.get<PaymentResponse>("/payments/input", {
      // const response = await API.get<PaymentResponse>("/back/payments/input", {
      params,
      headers: { Authorization: `Bearer ${token}` },
    });

    return response.data;
  } catch (error: any) {
    const status = error?.response?.status;

    if (status === 400) {
      console.error("📛 Error 400: Invalid request parameters.");
    } else if (status === 401) {
      console.error("🔒 Error 401: Unauthorized.");
    } else if (status === 500) {
      console.error("💥 Error 500: Internal Server Error.");
    } else {
      console.error("❌ Unknown error:", error);
    }

    throw error;
  }
};
